import { createAction, props } from '@ngrx/store';
import { AnamnesisQuestionnaireResponseHistory } from '../medical-record-page/pages/anamnesis/model/anamnesis-history.model';
import { QuestionariType, QuestionnaireResponse } from '../model/questionnaire-response';
import { ToxicityQuestionnaireResponseHistory } from '../medical-record-page/pages/toxicity/model/toxicity.model';
import { PhysicalExamQuestionnaireResponseHistory } from '../medical-record-page/pages/physical-exam/model/physical-exam-history.model';
import { VitalSigns } from '../medical-record-page/pages/vital-signs/model/vital-signs.model';
import { PatientInfoAPI } from '../medical-record-page/pages/patient-informations/model/patient.model';
import { Chemotherapy } from '../medical-record-page/pages/chemotherapy/model/chemotherapy.model';
import { EducationQuestionnaireResponse } from '../medical-record-page/pages/education/model/education_questionnaire.model';
import { PrescriptionProgram } from '../medical-record-page/pages/chemotherapy/model/treatment.interface';
import { SolicitationResponse } from '../medical-record-page/pages/exams-orders/model/solicitations.model';
import { NursingHistory } from '../medical-record-page/pages/nursing/model/nursing-history.model';
import { Ram } from '../medical-record-page/pages/ram/model/ram.model';
import { PharmacyIntervention } from '../medical-record-page/pages/pharmacy/models/pharmacy-intervation.model';
import { PharmacyAttention } from '../medical-record-page/pages/pharmacy/models/pharmacy-attention.model';
import { Nutrition } from './../medical-record-page/pages/nutrition/model/nutrition.model';
import { NursingAssessment } from '../medical-record-page/pages/nursing/model/nursing-assessment.model';
import { NursingDiagnosis } from './../medical-record-page/pages/nursing/model/nursing-diagnosis.model';
import { Evolution } from '../medical-record-page/pages/evolution/model/evolution.model';
import { Conduct } from '../medical-record-page/pages/conduct/model/conduct.model';

export enum MedicalRecordActionType {
  ADD_QUEST = '[med rec] add quest',
  EDIT_QUEST = '[med rec] edit quest',
  REMOVE_QUEST = '[med rec] remove quest',
  HIDE_PATIENT_NAME = 'HIDE_PATIENT_NAME',

  CLEAR_ALL_MR = 'clear all medical record',

  SET_PATIENT_INFORMATIONS = '[MEDICAL RECORD] Set Patient Informations',
  CLEAR_PATIENT_INFORMATIONS = '[MEDICAL RECORD] Clear Patient Informations',

  SET_OPEN_MEDICAL_RECORD = '[MEDICAL RECORD] - Set can open Patient Medical Record',

  SET_ANAMNESIS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set Anamnesis QuestionnaireResponse',
  UPDATE_TODAY_ANAMNESIS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update Today Anamnesis QuestionnaireResponse',
  CLEAR_ANAMNESIS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear Anamnesis QuestionnaireResponse',

  SET_EVOLUTION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set Evolution QuestionnaireResponse',
  CLEAR_EVOLUTION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear Evolution QuestionnaireResponse',
  UPDATE_TODAY_EVOLUTION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update Today Evolution QuestionnaireResponse',

  SET_PHYSICALEXAM_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set Physical Exam QuestionnaireResponse',
  CLEAR_PHYSICALEXAM_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear Physical Exam QuestionnaireResponse',
  UPDATE_TODAY_PHYSICALEXAM_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update Today Physical Exam QuestionnaireResponse',

  SET_TOXICITY_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set Toxicity QuestionnaireResponse',
  SAVE_TOXICITY_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] save Toxicity QuestionnaireResponse',
  CLEAR_TOXICITY_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear Toxicity QuestionnaireResponse',
  DELETE_TOXICITY_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] delete Toxicity QuestionnaireResponse',
  UPDATE_TODAY_TOXICITY_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update Today Toxicity QuestionnaireResponse',

  SET_VITALSIGNS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set Vital Signs QuestionnaireResponse',
  CLEAR_VITALSIGNS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear Vital Signs QuestionnaireResponse',
  SAVE_VITALSIGNS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] SAVE_VITALSIGNS_QUESTIONNAIRE_RESPONSE',
  DELETE_VITALSIGNS_QUESTIONNAIRE_RESPONSE = 'DELETE_VITALSIGNS_QUESTIONNAIRE_RESPONSE',
  UPDATE_TODAY_VITALSIGNS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update Today Vital Signs QuestionnaireResponse',

  SET_CONDUCT_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set Conduct QuestionnaireResponse',
  SET_CONDUCT_TODAY = '[MEDICAL RECORD] Set Conduct Today',
  CLEAR_CONDUCT_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear Conduct QuestionnaireResponse',
  SAVE_CONDUCT_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Save Conduct QuestionnaireResponse',
  DELETE_CONDUCT_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Delete Conduct QuestionnaireResponse',
  UPDATE_TODAY_CONDUCT_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update Conduct Toxicity QuestionnaireResponse',

  SET_SOLICITATIONS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set SOLICITATIONS QuestionnaireResponse',
  CLEAR_SOLICITATIONS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear SOLICITATIONS QuestionnaireResponse',
  SAVE_SOLICITATIONS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Save SOLICITATIONS QuestionnaireResponse',
  DELETE_SOLICITATIONS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Delete SOLICITATIONS QuestionnaireResponse',
  UPDATE_SOLICITATIONS_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update SOLICITATIONS QuestionnaireResponse',

  SET_EDUCATION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set Education QuestionnaireResponse',
  SET_EDUCATION_TODAY = '[MEDICAL RECORD] Set Education Today',
  SET_EDUCATION_history = '[MEDICAL RECORD] Set Education history',
  CLEAR_EDUCATION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear Education QuestionnaireResponse',
  SAVE_EDUCATION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Save Education QuestionnaireResponse',
  DELETE_EDUCATION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Delete Education QuestionnaireResponse',
  UPDATE_TODAY_EDUCATION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update Today Education QuestionnaireResponse',

  SET_CHEMOTHERAPY = '[MEDICAL RECORD] - Set Patient Chemotherapy',
  SET_CHEMOTHERAPY_TREATMENT = '[MEDICAL RECORD] - Set Patient Chemotherapy treatment',
  DELETE_CHEMOTHERAPY_TREATMENT = '[MEDICAL RECORD] - Delete Patient Chemotherapy treatment',
  EDIT_CHEMOTHERAPY_TREATMENT = '[MEDICAL RECORD] - Edit Patient Chemotherapy treatment',
  UPDATE_CHEMOTHERAPY_TREATMENT = '[MEDICAL RECORD] - Update Patient Chemotherapy treatment',
  CONFIRM_EDIT_CHEMOTHERAPY_PRESCRIPTION = '[MEDICAL RECORD] - Confirm/Edit Patient Chemotherapy prescription',
  DELETE_CHEMOTHERAPY_PRESCRIPTION = '[MEDICAL RECORD] - Delete Patient Chemotherapy prescription',
  CLEAR_CHEMOTHERAPY = '[MEDICAL RECORD] Clear Chemotherapy',

  SET_NURSING = '[MEDICAL RECORD] Set Nursing QuestionnaireResponse',
  CLEAR_NURSING = '[MEDICAL RECORD] Clear Nursing QuestionnaireResponse',
  UPDATE_NURSING = '[MEDICAL RECORD] Update Nursing Array',

  SET_NURSINGHISTORY = '[MEDICAL RECORD] Set Nursing History QuestionnaireResponse',
  CLEAR_NURSINGHISTORY = '[MEDICAL RECORD] Clear Nursing History QuestionnaireResponse',
  UPDATE_TODAY_NURSINGHISTORY = '[MEDICAL RECORD] Update Today Nursing History QuestionnaireResponse',

  SET_NURSINGAVALIATION = '[MEDICAL RECORD] Set Nursing Assessment QuestionnaireResponse',
  CLEAR_NURSINGAVALIATION = '[MEDICAL RECORD] Clear Nursing Assessment QuestionnaireResponse',
  UPDATE_TODAY_NURSINGAVALIATION = '[MEDICAL RECORD] Update Today Nursing Assessment QuestionnaireResponse',

  SET_NURSINGDIAGNOSIS = '[MEDICAL RECORD] Set Nursing Assessment QuestionnaireResponse',
  CLEAR_NURSINGDIAGNOSIS = '[MEDICAL RECORD] Clear Nursing Assessment QuestionnaireResponse',
  UPDATE_TODAY_NURSINGDIAGNOSIS = '[MEDICAL RECORD] Update Today Nursing Assessment QuestionnaireResponse',

  SET_RAM_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set RAM QuestionnaireResponse',
  CLEAR_RAM_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear RAM QuestionnaireResponse',
  UPDATE_RAM_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update Today RAM QuestionnaireResponse',

  SET_PHARMACY = '[MEDICAL RECORD] Set Pharmacy QuestionnaireResponse',
  CLEAR_PHARMACY = '[MEDICAL RECORD] Clear Pharmacy QuestionnaireResponse',

  SET_PHARMACY_ATTENTION = '[MEDICAL RECORD] Set Pharmacy Attention QuestionnaireResponse',
  CLEAR_PHARMACY_ATTENTION_RESPONSE = '[MEDICAL RECORD] Clear Pharmacy Attention QuestionnaireResponse',
  UPDATE_PHARMACY_ATTENTION_RESPONSE = '[MEDICAL RECORD] Update Today Pharmacy Attention QuestionnaireResponse',

  SET_PHARMACY_INTERVENTION = '[MEDICAL RECORD] Set Pharmacy Intervention QuestionnaireResponse',
  CLEAR_PHARMACY_INTERVENTION_RESPONSE = '[MEDICAL RECORD] Clear Pharmacy Intervention QuestionnaireResponse',
  UPDATE_PHARMACY_INTERVENTION_RESPONSE = '[MEDICAL RECORD] Update Today Pharmacy Intervention QuestionnaireResponse',

  SET_NUTRITION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Set Nutrition QuestionnaireResponse',
  CLEAR_NUTRITION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Clear Nutrition QuestionnaireResponse',
  UPDATE_NUTRITION_QUESTIONNAIRE_RESPONSE = '[MEDICAL RECORD] Update Today Nutrition QuestionnaireResponse',

  SET_PSYCHOLOGY = '[MEDICAL RECORD] Set Psychology QuestionnaireResponse',
  CLEAR_PSYCHOLOGY = '[MEDICAL RECORD] Clear Psychology QuestionnaireResponse',
  UPDATE_PSYCHOLOGY_TODAY = '[MEDICAL RECORD] Update Today Psychology QuestionnaireResponse',
}

// PATIENT INFORMATIONS
export const setPatientInformations = createAction(
  MedicalRecordActionType.SET_PATIENT_INFORMATIONS,
  props<{ patient: PatientInfoAPI }>()
);

export const clearPatientInformations = createAction(
  MedicalRecordActionType.CLEAR_PATIENT_INFORMATIONS
);

// CAN OPEN MEDICAL RECORD
export const setHidePatientName = createAction(
  MedicalRecordActionType.HIDE_PATIENT_NAME,
);

// Valido para qualquer Questionário Médico :
export const addQuestionnaire = createAction(
  MedicalRecordActionType.ADD_QUEST,
  props<QuestionariType>()
);

export const updateQuestionnaire = createAction(
  MedicalRecordActionType.EDIT_QUEST,
  props<QuestionariType>()
);

export const removeQuestionnaire = createAction(
  MedicalRecordActionType.EDIT_QUEST,
  props<{
    questId: number
  } | {
    indexToDelete: number
  }>()
);

// Aplicados em todos os Prontuarios (questionarios e não questionarios)
export const clearAllMedicalRecord = createAction(
  MedicalRecordActionType.CLEAR_ALL_MR
);

// ANAMNESIS
export const setAnamnesisQuestionnaireResponse = createAction(
  MedicalRecordActionType.SET_ANAMNESIS_QUESTIONNAIRE_RESPONSE,
  props<{
    anamnesisQuestionnaireResponse: QuestionnaireResponse<AnamnesisQuestionnaireResponseHistory>
  }>()
);

export const updateTodayAnamnesisQuestionnaireResponse = createAction(
  MedicalRecordActionType.UPDATE_TODAY_ANAMNESIS_QUESTIONNAIRE_RESPONSE,
  props<{
    today: AnamnesisQuestionnaireResponseHistory
  }>()
);

export const clearAnamnesisQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_ANAMNESIS_QUESTIONNAIRE_RESPONSE
);

// EVOLUTION
export const setEvolutionQuestionnaireResponse = createAction(
  MedicalRecordActionType.SET_EVOLUTION_QUESTIONNAIRE_RESPONSE,
  props<{
    evolutionQuestionnaireResponse: QuestionnaireResponse<Evolution>;
  }>()
);

export const clearEvolutionQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_EVOLUTION_QUESTIONNAIRE_RESPONSE
);

export const updateTodayEvolutionQuestionnaireResponse = createAction(
  MedicalRecordActionType.UPDATE_TODAY_EVOLUTION_QUESTIONNAIRE_RESPONSE,
  props<{
    today: Evolution
  }>()
);

// PHYSICAL EXAM
export const setPhysicalExamQuestionnaireResponse = createAction(
  MedicalRecordActionType.SET_PHYSICALEXAM_QUESTIONNAIRE_RESPONSE,
  props<{
    physicalExamQuestionnaireResponse: QuestionnaireResponse<PhysicalExamQuestionnaireResponseHistory>;
  }>()
);

export const clearPhysicalExamQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_PHYSICALEXAM_QUESTIONNAIRE_RESPONSE
);

export const updateTodayPhysicalExamQuestionnaireResponse = createAction(
  MedicalRecordActionType.UPDATE_TODAY_PHYSICALEXAM_QUESTIONNAIRE_RESPONSE,
  props<{
    today: PhysicalExamQuestionnaireResponseHistory
  }>()
);

// TOXICITY
export const setToxicityQuestionnaireResponse = createAction(
  MedicalRecordActionType.SET_TOXICITY_QUESTIONNAIRE_RESPONSE,
  props<{
    toxicityQuestionnaireResponse: QuestionnaireResponse<ToxicityQuestionnaireResponseHistory>;
  }>()
);

export const saveToxicityQuestionnaireResponse = createAction(
  MedicalRecordActionType.SAVE_TOXICITY_QUESTIONNAIRE_RESPONSE,
  props<{ newItem: ToxicityQuestionnaireResponseHistory }>()
);

export const clearToxicityQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_TOXICITY_QUESTIONNAIRE_RESPONSE
);

export const deleteToxicityQuestionnaireResponse = createAction(
  MedicalRecordActionType.DELETE_TOXICITY_QUESTIONNAIRE_RESPONSE,
  props<{ indexToDelete: number }>()
);

export const updateTodayToxicityQuestionnaireResponse = createAction(
  MedicalRecordActionType.UPDATE_TODAY_TOXICITY_QUESTIONNAIRE_RESPONSE,
  props<{
    today: ToxicityQuestionnaireResponseHistory
  }>()
);

// SOLICITATIONS
export const setSolicitations = createAction(
  MedicalRecordActionType.SET_SOLICITATIONS_QUESTIONNAIRE_RESPONSE,
  props<{ solicitations: SolicitationResponse[] }>()
);

export const saveSolicitations = createAction(
  MedicalRecordActionType.SAVE_SOLICITATIONS_QUESTIONNAIRE_RESPONSE,
  props<{ newItem: SolicitationResponse; newDate?: string }>()
);

export const clearSolicitations = createAction(
  MedicalRecordActionType.CLEAR_SOLICITATIONS_QUESTIONNAIRE_RESPONSE
);

export const deleteSolicitations = createAction(
  MedicalRecordActionType.DELETE_SOLICITATIONS_QUESTIONNAIRE_RESPONSE,
  props<{ indexToDelete: number }>()
);

export const updateSolicitation = createAction(
  MedicalRecordActionType.UPDATE_SOLICITATIONS_QUESTIONNAIRE_RESPONSE,
  props<SolicitationResponse>()
);

// VITAL SIGNS
export const setVitalSignsQuestionnaireResponse = createAction(
  MedicalRecordActionType.SET_VITALSIGNS_QUESTIONNAIRE_RESPONSE,
  props<{
    vitalSignsQuestionnaireResponse: QuestionnaireResponse<VitalSigns>;
  }>()
);

export const saveVitalSignsQuestionnaireResponse = createAction(
  MedicalRecordActionType.SAVE_VITALSIGNS_QUESTIONNAIRE_RESPONSE,
  props<{ newItem: VitalSigns; newDate?: string }>()
);

export const clearVitalSignsQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_VITALSIGNS_QUESTIONNAIRE_RESPONSE
);

export const deleteVitalSignsQuestionnaireResponse = createAction(
  MedicalRecordActionType.DELETE_VITALSIGNS_QUESTIONNAIRE_RESPONSE,
  props<{ indexToDelete: number }>()
);

export const updateTodayVitalSignsQuestionnaireResponse = createAction(
  MedicalRecordActionType.UPDATE_TODAY_VITALSIGNS_QUESTIONNAIRE_RESPONSE,
  props<{
    today: VitalSigns
  }>()
);

// CONDUCT
export const setConductQuestionnaireResponse = createAction(
  MedicalRecordActionType.SET_CONDUCT_QUESTIONNAIRE_RESPONSE,
  props<{
    conductQuestionnaireResponse: QuestionnaireResponse<Conduct>;
  }>()
);

export const updateTodayConduct = createAction(
  MedicalRecordActionType.SET_CONDUCT_TODAY,
  props<{
    today: Conduct;
  }>()
);

export const clearConductQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_CONDUCT_QUESTIONNAIRE_RESPONSE
);

// EDUCATION
export const setEducationQuestionnaireResponse = createAction(
  MedicalRecordActionType.SET_EDUCATION_QUESTIONNAIRE_RESPONSE,
  props<{
    education: EducationQuestionnaireResponse;
  }>()
);

export const setEducationToday = createAction(
  MedicalRecordActionType.SET_EDUCATION_TODAY,
  props<{
    education: EducationQuestionnaireResponse;
  }>()
);

export const clearEducationQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_EDUCATION_QUESTIONNAIRE_RESPONSE
);

export const updateTodayEducationQuestionnaireResponse = createAction(
  MedicalRecordActionType.UPDATE_TODAY_EDUCATION_QUESTIONNAIRE_RESPONSE,
  props<{
    today: EducationQuestionnaireResponse
  }>()
);

// CHEMOTHERAPY
export const setChemotherapy = createAction(
  MedicalRecordActionType.SET_CHEMOTHERAPY,
  props<{ chemoterapy: Chemotherapy[] }>()
);

export const setChemotherapyTreatment = createAction(
  MedicalRecordActionType.SET_CHEMOTHERAPY_TREATMENT,
  props<{ chemotherapy: Chemotherapy }>()
);

export const editChemotherapyTreatment = createAction(
  MedicalRecordActionType.EDIT_CHEMOTHERAPY_TREATMENT,
  props<{ chemotherapy: Chemotherapy, chemotherapyIndex: number }>()
);

export const deleteChemotherapyTreatment = createAction(
  MedicalRecordActionType.DELETE_CHEMOTHERAPY_TREATMENT,
  props<{ index: number }>()
);

export const confirmEditChemotherapyPrescription = createAction(
  MedicalRecordActionType.CONFIRM_EDIT_CHEMOTHERAPY_PRESCRIPTION,
  props<{ treatmentIndex: number, data: PrescriptionProgram[], scheduleIndex: number, detailIndex: number, practitionerId: string }>()
);

export const clearChemotherapy = createAction(
  MedicalRecordActionType.CLEAR_CHEMOTHERAPY
);

//RAM
export const setRamQuestionnaireResponse = createAction(
  MedicalRecordActionType.SET_RAM_QUESTIONNAIRE_RESPONSE,
  props<{ ramHistoryQuestionnaireResponse: QuestionnaireResponse<Ram>; }>()
);

export const clearRamQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_RAM_QUESTIONNAIRE_RESPONSE
);

export const updateTodayRamQuestionnaireResponse = createAction(
  MedicalRecordActionType.UPDATE_RAM_QUESTIONNAIRE_RESPONSE,
  props<{ today: Ram }>()
);

//PHARMACY
export const setPharmacy = createAction(
  MedicalRecordActionType.SET_PHARMACY,
  props<{ pharmacy: any }>()
);

export const clearPharmacy = createAction(
  MedicalRecordActionType.CLEAR_PHARMACY
);

//PHARMACY ATTENTION
export const setPharmacyAttention = createAction(
  MedicalRecordActionType.SET_PHARMACY_ATTENTION,
  props<{
    pharmacyAttention: QuestionnaireResponse<PharmacyAttention>
  }>()
);

export const clearPharmacyAttentionQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_PHARMACY_ATTENTION_RESPONSE
);

export const updateTodayPharmacyAttention = createAction(
  MedicalRecordActionType.UPDATE_PHARMACY_ATTENTION_RESPONSE,
  props<{ today: any }>()
);

//PHARMACY INTERVENTION
export const setPharmacyIntervention = createAction(
  MedicalRecordActionType.SET_PHARMACY_INTERVENTION,
  props<{
    pharmacyIntervention: QuestionnaireResponse<PharmacyIntervention>
  }>()
);

export const clearPharmacyInterventionQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_PHARMACY_INTERVENTION_RESPONSE
);

export const updateTodayPharmacyIntervention = createAction(
  MedicalRecordActionType.UPDATE_PHARMACY_INTERVENTION_RESPONSE,
  props<{ today: any }>()
);

//NUTRITION
export const setNutritionQuestionnaireResponse = createAction(
  MedicalRecordActionType.SET_NUTRITION_QUESTIONNAIRE_RESPONSE,
  props<{ nutritionHistoryQuestionnaireResponse: QuestionnaireResponse<Nutrition>; }>()
);

export const clearNutritionQuestionnaireResponse = createAction(
  MedicalRecordActionType.CLEAR_NUTRITION_QUESTIONNAIRE_RESPONSE
);

export const updateTodayNutritionQuestionnaireResponse = createAction(
  MedicalRecordActionType.UPDATE_NUTRITION_QUESTIONNAIRE_RESPONSE,
  props<{ today: any }>()
);

//NURSING
export const setNursing = createAction(
  MedicalRecordActionType.SET_NURSING,
  props<{ nursing: any }>()
);

export const clearNursing = createAction(
  MedicalRecordActionType.CLEAR_NURSING
);

//NURSING HISTORY
export const setNursingHistory = createAction(
  MedicalRecordActionType.SET_NURSINGHISTORY,
  props<{ nursingHistory: QuestionnaireResponse<NursingHistory>; }>()
);

export const clearNursingHistory = createAction(
  MedicalRecordActionType.CLEAR_NURSINGHISTORY
);

export const updateTodayNursingHistory = createAction(
  MedicalRecordActionType.UPDATE_TODAY_NURSINGHISTORY,
  props<{ today: any }>()
);

//NURSING AVALIATION
export const setNursingAvaliation = createAction(
  MedicalRecordActionType.SET_NURSINGAVALIATION,
  props<{ nursingAvaliation: QuestionnaireResponse<NursingAssessment>; }>()
);

export const clearNursingAvaliation = createAction(
  MedicalRecordActionType.CLEAR_NURSINGAVALIATION
);

export const updateTodayNursingAvaliation = createAction(
  MedicalRecordActionType.UPDATE_TODAY_NURSINGAVALIATION,
  props<{ today: any }>()
);

//NURSING DIAGNOSIS
export const setNursingDiagnosis = createAction(
  MedicalRecordActionType.SET_NURSINGDIAGNOSIS,
  props<{ nursingDiagnostic: QuestionnaireResponse<NursingDiagnosis>; }>()
);

export const clearNursingDiagnosis = createAction(
  MedicalRecordActionType.CLEAR_NURSINGDIAGNOSIS
);

export const updateTodayNursingDiagnosis = createAction(
  MedicalRecordActionType.UPDATE_TODAY_NURSINGDIAGNOSIS,
  props<{ today: any }>()
);

//PSYCHOLOGY
export const setPsychology = createAction(
  MedicalRecordActionType.SET_PSYCHOLOGY,
  props<{ psychology: QuestionnaireResponse<any>; }>()
);

export const updatePsychology = createAction(
  MedicalRecordActionType.UPDATE_PSYCHOLOGY_TODAY,
  props<{ psychology: any }>()
);

export const clearPsychology = createAction(
  MedicalRecordActionType.CLEAR_PSYCHOLOGY
);
